import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)
//
// Este archivo carga y registra todos tus controladores.
// Reemplaza todo su contenido con esto.

import { application } from "./application"

// --- Importa y registra tus controladores uno por uno ---
import AddUserController from "./add_user_controller.js"
application.register("add-user", AddUserController)

import AdaptiveSyncController from "./adaptive_sync_controller.js"
application.register("adaptive-sync", AdaptiveSyncController)

import BikeHunterTabsController from "./bike_hunter_tabs_controller.js"
application.register("bike-hunter-tabs", BikeHunterTabsController)

import DatepickerController from "./datepicker_controller.js"
application.register("datepicker", DatepickerController)

import DebounceController from "./debounce_controller.js"
application.register("debounce", DebounceController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown", DropdownController)

import DropdownFilterController from "./dropdown_filter_controller.js"
application.register("dropdown-filter", DropdownFilterController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import TicketDragController from "./ticket_drag_controller.js"
application.register("ticket-drag", TicketDragController)

import TicketNotasController from "./ticket_notas_controller.js"
application.register("ticket-notas", TicketNotasController)

import TicketFilterController from "./ticket_filter_controller.js"
application.register("ticket-filter", TicketFilterController)

import NotificationController from "./notification_controller.js"
application.register("notification", NotificationController)

import PasswordToggleController from "./password_toggle_controller.js"
application.register("password-toggle", PasswordToggleController)

import TicketResolutionController from "./ticket_resolution_controller.js"
application.register("ticket-resolution", TicketResolutionController)

import TicketResolutionFormController from "./ticket_resolution_form_controller.js"
application.register("ticket-resolution-form", TicketResolutionFormController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import SchedulerReloaderController from "./scheduler_reloader_controller.js"
application.register("scheduler-reloader", SchedulerReloaderController)

import ScrollRememberController from "./scroll_remember_controller.js"
application.register("scroll-remember", ScrollRememberController)

import MobileTicketsController from "./mobile_tickets_controller.js"
application.register("mobile-tickets", MobileTicketsController)

import MobileHeaderController from "./mobile_header_controller.js"
application.register("mobile-header", MobileHeaderController)

import CardZoomController from "./card_zoom_controller.js"
application.register("card-zoom", CardZoomController)

import EnRutaToggleController from "./en_ruta_toggle_controller.js"
application.register("en-ruta-toggle", EnRutaToggleController)

import GeocodeNotificationController from "./geocode_notification_controller.js"
application.register("geocode-notification", GeocodeNotificationController)

import DetailsDropdownController from "./details_dropdown_controller.js"
application.register("details-dropdown", DetailsDropdownController)

import FormSubmitController from "./form_submit_controller.js"
application.register("form-submit", FormSubmitController)

// --- Registra controladores de terceros ---
import Autocomplete from 'stimulus-autocomplete'
application.register('autocomplete', Autocomplete)